export default "__VITE_ASSET__b2adc548__"